import { Format, FORMAT_MIME_TYPES } from './formats';
import { convertToJSONL } from './json/json-preprocessor';

interface PreprocessFileOptions {
  file: File;
  format: Format;
}

/**
 * Preprocesses a file based on its format.
 * For JSON files, converts to JSONL format while maintaining JSON mime type.
 * For other formats, returns the original file without reading content.
 */
export async function preprocessFile({ file, format }: PreprocessFileOptions): Promise<File> {
  // Only preprocess JSON files
  if (format === Format.JSON) {
    try {
      const jsonText = await file.text();
      const jsonlText = convertToJSONL(jsonText);
      
      // Create new file with same name but processed content
      // Keep using JSON mime type since we're maintaining JSON format in UI
      return new File(
        [jsonlText], 
        file.name, 
        { type: FORMAT_MIME_TYPES[Format.JSON] }
      );
    } catch (error) {
      throw new Error(`Failed to preprocess JSON file: ${error instanceof Error ? error.message : String(error)}`);
    }
  }
  
  // For all other formats, return the original file
  return file;
} 